<template>
    <div class='PaneHeader row'>
        <h3 v-if='thisCardType == "ItemCard"' class='closed-name'>{{ product.name }}</h3>
        <div v-if='thisCardType == "ItemHistory"' class='cardName'>
            <h4>Item History</h4>
            <a class='unlockEdit' @click="CardUnlocked=!CardUnlocked">
                <UnlockedIcon :class="{hidden: !CardUnlocked}" />
                <LockedIcon :class="{hidden: CardUnlocked}" />
            </a>
        </div>
    </div>
</template>

<script>
    import UnlockedIcon from '../../icons/UnlockedIcon'
    import LockedIcon from '../../icons/LockedIcon'
    export default{
        name: 'PaneHeader',
        props:['product', 'cardType'],
        components:{
            UnlockedIcon,
            LockedIcon      
        },
        data() {
            return {
                collapsed: false,
                thisCardType: this.$props.cardType,
                CardUnlocked: false
            };
        }
    }
</script>